import { useStaticQuery, graphql } from 'gatsby'

export const useCmsPlpQuery = () => {
  const { allCmsPlp }: TAllCmsPlp = useStaticQuery(graphql`
    query cmsPlpQuery {
      allCmsPlp {
        edges {
          node {
            sections {
              name
              data
            }
          }
        }
      }
    }
  `)

  return {
    allCmsPlp,
  }
}
